import { render, staticRenderFns } from "./TenantViewCard.vue?vue&type=template&id=5a4f5d0c&"
import script from "./TenantViewCard.vue?vue&type=script&lang=js&"
export * from "./TenantViewCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports